import React from 'react';
import {Form, Header} from 'semantic-ui-react';
import {
  TextBoxField,
  InlineSelect,
  InlineDateBoxField,
  RadioField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import STATE_OPTIONS from 'app-ui-componentlibrary/dist/common/states';
import REGION_OPTIONS from '../taskList/regions';
import _ from 'lodash';
import {MultiSelect} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';

class TaskFilter extends React.Component {
  setFilter = (name, value) => {
    const filtersAsEntered = _.cloneDeep(this.props.filtersAsEntered);
    filtersAsEntered[name] = value;
    this.props.onFilterChange(filtersAsEntered);
  };

  getBoolean = (value) => {
    switch (value) {
      case false:
      case 'false':
        return false;
      case true:
      case 'true':
        return true;
      default:
        return '';
    }
  };

  setFollowUpFilter = (name, value) => {
    value = this.getBoolean(value);
    this.setFilter(name, value);
  };

  clearAllFilters = () => {
    this.props.onFilterClear();
  };

  render() {
    const {fundingOpps} = this.props;
    const filtersAsEntered = _.get(this.props, 'filtersAsEntered', {});
    const sortOptions = _.get(this.props, 'sortOptions', {});
    const filteredAssignees = _.filter(this.props.assigneeList, function (el) {
      return el != null;
    });

    const assigneeOptions = _.concat(
      [{key: 0, value: '', text: ''}],
      [{key: 'unassigned', value: 'unassigned', text: 'unassigned'}],
      _.map(_.sortBy(_.values(filteredAssignees)), (item) => ({
        key: item,
        value: item,
        text: _.get(
          _.find(this.props.userObjs, (user) => user.userId === item),
          'emailAdr',
          'Unknown Email'
        ),
      }))
    );

    const foOptions = _.reverse(
      _.map(fundingOpps, (fo) => ({
        key: fo.fundingOpportunityId,
        value: fo.fundingOpportunityId,
        text: fo.fundingOpportunityName,
      }))
    );

    const fundingOpportunityOptions = [{key: 0, value: '', text: ''}, ...foOptions];

    return (
      <Form>
        <Header as="h3">Search</Header>
        <TextBoxField
          title="Search by grant ID"
          value={filtersAsEntered.grantId}
          name="grantId"
          label="Grant ID"
          id="grantId"
          handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
        />
        <TextBoxField
          title="Search by Subgrant ID"
          value={filtersAsEntered.subGrantId}
          name="subGrantId"
          label="Subgrant ID"
          id="subGrantId"
          handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
        />
        <Header as="h6" textAlign="right">
          <a href="#" className="table-link" tabIndex="0" onClick={this.clearAllFilters}>
            Clear Filters
          </a>
        </Header>
        <TextBoxField
          title="organizationName"
          value={filtersAsEntered.organizationName}
          name="organizationName"
          label="Organization name"
          id="organizationName"
          handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
        />
        <TextBoxField
          title="subOrganizationName"
          value={filtersAsEntered.subOrganizationName}
          name="subOrganizationName"
          label="Suborganization Name"
          id="subOrganizationName"
          handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
        />
        <InlineSelect
          placeholder="State"
          id="organizationState"
          label="State"
          title="organizationState"
          name="organizationState"
          value={filtersAsEntered.organizationState}
          handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
          options={STATE_OPTIONS}
        />
        <InlineSelect
          placeholder="region"
          id="region"
          label="Region"
          title="region"
          name="region"
          value={filtersAsEntered.region}
          handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
          options={REGION_OPTIONS}
        />

        <InlineSelect
          placeholder=""
          id="assignee"
          label="Assigned to"
          title="assignee"
          name="assignee"
          value={filtersAsEntered.assignee}
          handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
          options={assigneeOptions}
        />
        {!_.includes(this.props.toggles, 'disasterSiteNav') && (
          <InlineSelect
            placeholder=""
            id="fundingOpportunityId"
            label="Filter by funding opportunity"
            title="fundingOpportunityId"
            name="fundingOpportunityId"
            value={filtersAsEntered.fundingOpportunityId}
            handleChange={(e) =>
              this.setFilter(
                e.target.name,
                e.target.value !== '' ? _.toNumber(e.target.value) : ''
              )
            }
            options={fundingOpportunityOptions}
          />
        )}
        {_.includes(this.props.toggles, 'disasterSiteNav') && (
          <MultiSelect
            placeholder=""
            id="fundingOpportunityId"
            label="Filter by funding opportunity"
            title="fundingOpportunityId"
            name="fundingOpportunityId"
            search={true}
            value={filtersAsEntered.fundingOpportunityId}
            onChange={(e, data) => this.setFilter(data.id, data.value)}
            options={fundingOpportunityOptions}
          />
        )}
        <Header as="h5">Date in queue</Header>
        <Form.Group widths="equal">
          <InlineDateBoxField
            title="From date in queue"
            label="From date"
            id="createdAfter"
            name="createdAfter"
            value={filtersAsEntered.createdAfter}
            handleChange={(e, data) => this.setFilter(e.target.name, data.value)}
            placeholder="yyyy-mm-dd"
          />
          <InlineDateBoxField
            title="To date in queue"
            label="To date"
            id="createdBefore"
            name="createdBefore"
            value={filtersAsEntered.createdBefore}
            handleChange={(e, data) => this.setFilter(e.target.name, data.value)}
            placeholder="yyyy-mm-dd"
          />
        </Form.Group>
        <InlineSelect
          placeholder=""
          id="followUpRequired"
          label="Flagged for follow-up"
          labeled="true"
          title="followUpRequired"
          name="followUpRequired"
          value={filtersAsEntered.followUpRequired}
          handleChange={(e) => this.setFollowUpFilter(e.target.name, e.target.value)}
          options={[
            {key: '', value: null, text: ''},
            {key: 'flagged', text: 'Flagged for follow-up', value: true},
            {
              key: 'notFlagged',
              text: 'Not flagged for follow-up',
              value: false,
            },
          ]}
        />
        <Header as="h3">Sort</Header>
        <InlineSelect
          placeholder="Sort by"
          search
          selection
          title="Sort"
          value={sortOptions.sortBy}
          name="sortBy"
          id="sortBy"
          label="Sort by"
          handleChange={(e) => this.props.setSortBy(e.target.value)}
          options={[
            {key: 'DateInQueue', value: 'created', text: 'Date in queue'},
            {key: 'Grant ID', value: 'grantId', text: 'Grant ID'},
            {key: 'Subgrant ID', value: 'subGrantId', text: 'Subgrant ID'},
            {
              key: 'Suborganization',
              value: 'subOrganizationName',
              text: 'Suborganization',
            },
            {
              key: 'Organization',
              value: 'organizationName',
              text: 'Organization',
            },
            {key: 'TaskType', value: 'name', text: 'Task'},
            {key: 'Priority rank', value: 'priority', text: 'Priority Rank'},
          ]}
        />
        <Form.Field>
          <RadioField
            name="sortOrder"
            handleChange={(e) => this.props.setSortOrder(e.target.value)}
            value={sortOptions.sortOrder}
            options={[
              {label: 'Ascending (A-Z)', value: 'asc'},
              {label: 'Descending (Z-A)', value: 'desc'},
            ]}
          />
        </Form.Field>
      </Form>
    );
  }
}

export default TaskFilter;
